var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Header')],1),_c('div',{staticClass:"router-view"},[_c('div',[_c('LeftLevelNavigation')],1),_c('div',{staticClass:"router-view-main"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }